import 'whatwg-fetch'
import {RaisedButton} from "material-ui";

const React = require('react');

export default class BasicRow extends React.Component {
    render() {
        return (
            <tr>
                <td>{this.props.name}</td>
                <td>
                    <RaisedButton
                        primary
                        label={"Edit"}
                        onClick={() => this.props.onEditClicked(this.props.id, this.props.name)}/>

                    <RaisedButton
                        style={{marginLeft: '10px'}}
                        secondary
                        label={"Delete"}
                        onClick={() => this.props.onDeleteClicked(this.props.index, this.props.id)}/>
                </td>

                {this.props.extraTd}
            </tr>
        )
    }
}
